import { builderLightText } from '@/blocks/utils'
import { AccessibleText } from '@/components/AccessibleText'
import { ButtonLink } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { HeadingS } from '@/components/Typography'

import { useSuppressOthers } from '@/hooks/useSuppressOthers'

import type { ModalContentComponentProps } from '../types'

import { ModalContentStyles } from './styles'

export const ModalContent = ({
  hidden,
  onClose,
  title,
  accessibleTitle,
  colorModifier,
  subtitle,
  cta,
  modalRef,
  dialogRef,
}: ModalContentComponentProps) => {
  const lightText = builderLightText(colorModifier)

  useSuppressOthers([dialogRef], !hidden)

  return (
    <ModalContentStyles
      ref={modalRef}
      role="dialog"
      aria-modal="true"
      hidden={hidden}
      tabIndex={-1}
    >
      <div className="modal-header" ref={dialogRef}>
        <AccessibleText
          id="modal-title-accessible"
          tag="h5"
          text={title}
          accessibleText={accessibleTitle}
          className="modal-title"
          light={lightText}
        />
        <button onClick={onClose} className="modal-close" aria-label="Fechar caixa de diálogo">
          <Icon icon="close" width={24} height={24} />
        </button>
      </div>
      {subtitle && (
        <HeadingS aria-hidden light={lightText} className="modal-subtitle" tag="p">
          {subtitle}
        </HeadingS>
      )}
      <div className="cta-wrapper">
        {cta && cta.label && (
          <ButtonLink
            source={cta.link}
            aria-label={cta.ariaLabel}
            className="cta"
            modifier="solid"
            rounded
          >
            {cta.label}
          </ButtonLink>
        )}
      </div>
    </ModalContentStyles>
  )
}
